import {
  TFullProject,
  TLightProject,
  TMapProjects,
  TBestFeasibilities,
  TLightProjects,
} from 'App/features/searchEntities/lightProjects/lightProjectsTypes';
import {
  // USR-400 D01
  // LIGHT_PROJECTGROUPS_MODEL,
  OLD_LIGHT_PROJECTGROUPS_MODEL,
} from '../../../../components/common/pages_constants';
import BaseRequest from '../../../../baseRequest';

// USR-400 D01: move update to new API
function update(
  hash: string,
  fields: Record<string, string>,
): Promise<TLightProject> {
  const requester = new BaseRequest<TLightProject>(
    OLD_LIGHT_PROJECTGROUPS_MODEL,
  );
  return requester.patch(hash, {...fields});
}

// USR-400 D01: move delete to new API
function remove(hash: string): Promise<void> {
  const requester = new BaseRequest<void>(OLD_LIGHT_PROJECTGROUPS_MODEL);
  return requester.delete(hash);
}

function fetchLightProjects(
  queryParameters: Record<string, string>,
): Promise<TLightProjects> {
  const requester = new BaseRequest<TLightProjects>('newlightprojectgroups');
  return requester.getAll({queryParameters});
}

function fetchMapProjects(
  queryParameters: Record<string, string>,
): Promise<TMapProjects> {
  const requester = new BaseRequest<TMapProjects>(
    'newlightprojectgroups/list_for_map',
  );
  return requester.getAll({queryParameters});
}

function fetchBestFeasibilities(
  queryParameters: Record<string, string>,
): Promise<TBestFeasibilities> {
  const requester = new BaseRequest<TBestFeasibilities>(
    'newlightprojectgroups/best_faisabilities',
  );
  return requester.getAll({queryParameters});
}

function fetchFullProjects(hash_list: string[]): Promise<TFullProject[]> {
  const requester = new BaseRequest<TFullProject>('newlightprojectgroups/full'); // Mettre à jour usine avant de commit
  return requester.post({hash_list}) as unknown as Promise<TFullProject[]>;
}

export {
  update,
  remove,
  fetchLightProjects,
  fetchMapProjects,
  fetchBestFeasibilities,
  fetchFullProjects,
};
